import { toCamelCase } from '~/utils/object'
import { AxiosInstance, AxiosResponse } from 'axios'
import { inject } from 'tsyringe'
import { httpToken } from '~/constants/dependency-injection/tokens'

import { containerScoped } from '~/decorators/dependency-container'
import {
  Dealer,
  DealerPrefecture,
  DealersPerPrefecture
} from '~/models/dealer/types'
import { Category } from '~/models/dealer/map/types'
import { formatDealer } from '~/services/dealers/formatters'
import { invalidBodyError } from '../../errors'
@containerScoped()
export default class DealersPreviewService {
  constructor(@inject(httpToken) private http: AxiosInstance) {}

  async getPreview(dealerId: number | string): Promise<Dealer> {
    const response: AxiosResponse = await this.http.get(
      `/api/catalogue/dealers/${dealerId}/preview/`
    )
    const { data: body } = response
    if (!(body && body.data && body.data.dealer)) {
      throw invalidBodyError(body)
    }
    return formatDealer(body.data.dealer)
  }

  async getDealersLocationsList(
    strQuery: string = '',
    catQuery: number[]
  ): Promise<{
    formattedData: DealerPrefecture[]
    categories: Category[]
  }> {
    let url = '/api/catalogue/dealers/locations/' + `?q=${strQuery}`

    catQuery &&
      catQuery.forEach((q: number, i: number) =>
        i === 0 ? (url += `&category=${q}`) : (url += `&category=${q}`)
      )
    const response: AxiosResponse = await this.http.get(url)

    const {
      prefectures,
      categories
    }: {
      prefectures: DealerPrefecture[]
      categories: Category[]
    } = response.data.data

    const formattedData = prefectures.map(p => {
      return {
        ...p,
        prefecture: p.prefecture.toUpperCase()
      }
    })

    return { formattedData, categories }
  }

  async filterDealersList(queries: any): Promise<DealersPerPrefecture> {
    let url = '/api/catalogue/dealers/'

    queries.location
      ? (url = `${url}?pg=${queries.pg}&q=${queries.q}&sort=${queries.sort}&location=${queries.location}&without-markers=1`)
      : (url = `${url}?pg=${queries.pg}&q=${queries.q}&sort=${queries.sort}&without-markers=1`)

    if (queries.categories?.length) {
      const categoriesArray = queries.categories.split(',')
      categoriesArray.forEach((cat: string) => (url += `&category=${cat}`))
    }

    const response: AxiosResponse = await this.http.get(url)
    const data: DealersPerPrefecture = toCamelCase(response.data.data)

    return data
  }
}
